/**
 * XSSサニタイズユーティリティ
 *
 * v-html や innerHTML で外部データ（ユーザー入力・API応答）を
 * レンダリングする際に使用する。
 *
 * 使い分け:
 *   escapeHtml()    - プレーンテキストとして表示（最も安全）
 *   sanitizeHtml()  - 一部のHTMLタグを許可して表示
 *   escapeForAttr() - HTML属性値に埋め込む場合
 */

import DOMPurify from 'dompurify'

/**
 * HTMLエスケープ（プレーンテキスト化）
 * ユーザー入力やAPI応答をそのまま表示する場合に使用
 */
export function escapeHtml(str: string): string {
  if (!str) return ''
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

/**
 * DOMPurifyによるサニタイズ
 * リンクや基本的な書式を含むHTMLを安全にレンダリングする場合に使用
 */
export function sanitizeHtml(dirty: string): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['a', 'b', 'i', 'em', 'strong', 'br', 'span', 'div', 'p', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  })
}

/**
 * テキストをエスケープしてから改行を<br>に変換
 * メモやコメントの表示に使用
 */
export function escapeHtmlWithBreaks(str: string): string {
  if (!str) return ''
  return escapeHtml(str).replace(/\n/g, '<br>')
}
